import React, { useState } from 'react';
import {
  Box,
  TextField,
  Typography,
  Paper,
} from '@material-ui/core';
import axios from 'axios';


export function SearchBox({ onSearchResult, classes }) {
  const [searchTerm, setSearchTerm] = useState('');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = async (value) => {
    setSearchTerm(value);

    if (value.length < 3) {
      setResults([]);
      setShowResults(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(value)}&countrycodes=vn&limit=5`
      );

      if (response.data && response.data.length > 0) {
        setResults(response.data);
        setShowResults(true);
      } else {
        setResults([]);
        setShowResults(false);
      }
    } catch (error) {
      console.error('Search error:', error);
      setResults([]);
    }
  };

  const handleSelectResult = (result) => {
    const lat = parseFloat(result.lat);
    const lon = parseFloat(result.lon);

    setSearchTerm(result.display_name);
    setShowResults(false);

    if (onSearchResult) {
      onSearchResult([lat, lon]);
    }
  };

  return (
    <Box className={classes.searchBoxContainer}>
      <TextField
        fullWidth
        size="small"
        variant="outlined"
        placeholder="Tìm kiếm địa chỉ..."
        value={searchTerm}
        onChange={(e) => handleSearch(e.target.value)}
        onFocus={() => results.length > 0 && setShowResults(true)}
        className={classes.searchInput}
      />
      {showResults && results.length > 0 && (
        <Paper className={classes.searchResults}>
          {results.map((result, index) => (
            <Box
              key={index}
              className={classes.searchResultItem}
              onClick={() => handleSelectResult(result)}
            >
              <Typography variant="body2" className={classes.resultText}>
                {result.display_name}
              </Typography>
            </Box>
          ))}
        </Paper>
      )}
    </Box>
  );
}
